import { OrderFulfillmentType } from "@sellar-io/api-v2/types";

import { isCourierIntegrationFulfillmentType } from "@sellar-io/common";

export type MarkerEntityType = {
  id: number;
  urlId?: string;
  SupplierRetailerConnectionId?: number;
  Business: {
    name: string;
    logoUrl: string | null;
    Location?: { lat: number; lng: number } | null;
  };
};

export const getFulfillmentType = (
  fulfillmentType: OrderFulfillmentType | null | undefined,
) => {
  if (!fulfillmentType || isCourierIntegrationFulfillmentType(fulfillmentType))
    return "courier";

  return fulfillmentType;
};

export const defaultLondonLocation = {
  lat: 51.5,
  lng: 0.13,
};
